import { UseSuspenseQueryOptions, useMutation, useQueryClient } from '@tanstack/react-query';

import { Id } from '@feature/utils';
import { Validation } from '@feature/validation';
import { generateValidationApi, generateValidationOptions } from '@feature/validation/validationGenerator';

const validationApi = generateValidationApi('/validation/chapter');

const { getHistoryOptions, validateOptions, getCurrentOptions } = generateValidationOptions('chapter', validationApi);

export function getChapterValidationHistoryOptions(chapterId: Id): UseSuspenseQueryOptions<Validation[]> {
  return getHistoryOptions(chapterId);
}

export function getChapterValidationOptions(chapterId: Id): UseSuspenseQueryOptions<Validation | null> {
  return getCurrentOptions(chapterId);
}

export function useValidateChapter(chapterId: Id) {
  const queryClient = useQueryClient();
  return useMutation(validateOptions(chapterId, queryClient));
}
